var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:['banner', _vm.typeClass]},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}}),(_vm.closable)?_c('button',{staticClass:"banner-close",on:{"click":_vm.closeBanner}},[_vm._v("×")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }